import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import { ConsentGate } from "../features/legal/ConsentGate";

export const ProtectedRoute = ({ children, roles }) => {
  const { user, ready } = useAuth();
  const { t } = useTranslation();

  if (!ready)
    return (
      <div className="flex min-h-[100dvh] items-center justify-center text-sm text-muted-foreground">
        {t("app.loading")}
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.status === "onboarding") return <Navigate to="/complete-profile" replace />;
  if (user.status && user.status !== "active") return <Navigate to="/pending" replace />;
  if (["super_admin", "platform_admin"].includes(user.role)) return <Navigate to="/platform" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <ConsentGate>{children}</ConsentGate>;
};

export const PlatformRoute = ({ children }) => {
  const { user, ready } = useAuth();
  const { t } = useTranslation();

  if (!ready)
    return (
      <div className="flex min-h-[100dvh] items-center justify-center text-sm text-muted-foreground">
        {t("app.loading")}
      </div>
    );
  if (!user) return <Navigate to="/platform/login" replace />;
  if (!["super_admin", "platform_admin"].includes(user.role)) return <Navigate to="/" replace />;
  return children;
};
